import { styled } from 'styled-components'

import { Button } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

// TODO: Extract Section/SectionCard/SectionTitle to fe-core as a reusable bordered card pattern
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;
`

export const SectionTitle = styled.span`
  ${Typography.Title3}
  color: ${Colors.Semantic.Neutral.black};
`

export const SectionCard = styled.div`
  border: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
  border-radius: 0.25rem;
  padding: 1rem 0.75rem;
  background: ${Colors.Semantic.Neutral.light_grey};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  align-self: stretch;
`

export const ChangeButton = styled(Button)`
  flex-shrink: 0;
`
